export default __webpack_public_path__ + "static/media/GroupAdd.65ce2e07.svg";